import api from "./Api";

class TerminalPdvService {
  GetTerminalPdv(payload) {
    return api.get("/v1/TerminalPdv/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAllTerminalPdv() {
    return api.get("/v1/TerminalPdv").then((response) => {
      return response.data;
    });
  }

  PostTerminalPdv(payload) {
    return api.post("/v1/TerminalPdv", payload).then((response) => {
      return response.data;
    });
  }

  PutTerminalPdv(payload) {
    return api.put("/v1/TerminalPdv", payload).then((response) => {
      return response.data;
    });
  }

  AtivarTerminalPdv(payload) {
    return api
      .post("/v1/TerminalPdv/" + payload + "/Ativar")
      .then((response) => {
        return response.data;
      });
  }

  DesativarTerminalPdv(payload) {
    return api
      .post("/v1/TerminalPdv/" + payload + "/Desativar")
      .then((response) => {
        return response.data;
      });
  }

  ForcarCargaGeralTerminalPdv(payload) {
    return api
      .post("/v1/TerminalPdv/" + payload + "/ForcarCargaGeral")
      .then((response) => {
        return response.data;
      });
  }

  ForcarCargaGeralTodosTerminalPdv() {
    return api
      .post("/v1/TerminalPdv/ForcarCargaGeralTodos")
      .then((response) => {
        return response.data;
      });
  }

  GetPainel(payload) {
    return api.get("/v1/TerminalPdv/Painel" + payload).then((response) => {
      return response.data;
    });
  }

  GetMovimentacoes(payload) {
    return api
      .get("/v1/TerminalPdv/" + payload.id + "/Movimentacoes" + payload.query)
      .then((response) => {
        return response.data;
      });
  }
}

export default new TerminalPdvService();
